import React from "react";
import { ReviewAndConfirmContainer } from "../../../containers";
const ReviewAndConfirm = (props) => {
  return <ReviewAndConfirmContainer {...props} />;
};

export default ReviewAndConfirm;
